import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { profileService } from '../../services/users/profileService';
import { UserProfile } from '../../types';
import { isCoachAuthorized } from '../../utils/coachAuth';

interface CoachRouteProps {
  children: React.ReactNode;
}

const CoachRoute: React.FC<CoachRouteProps> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    const loadProfile = async () => {
      if (user?.id) {
        try {
          const userProfile = await profileService.getProfile(user.id);
          setProfile(userProfile);
        } catch (error) {
          console.error('Failed to load profile:', error);
          setProfile(null);
        }
        setProfileLoading(false);
      } else {
        setProfileLoading(false);
      }
    };

    loadProfile();
  }, [user]);

  if (authLoading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  // If not authenticated, send to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  // Allow access regardless of profile status - profile banner removed per ticket

  // Block non-coaches from coach portal
  if (profile && !isCoachAuthorized(profile)) {
    // Redirect to home, which will route them to their appropriate dashboard
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default CoachRoute;
